 document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector("sticky-header");
    if (!header) return;

    window.addEventListener("scroll", function () {
      if (window.scrollY > 100) {
        header.classList.add("scrolled");
      } else if (window.scrollY < 100) {
        header.classList.remove("scrolled");
      }
      else {
        header.classList.remove("scrolled");
      }
    });
  });
  
document.querySelectorAll('.btn_cstm').forEach(btn => {
  btn.addEventListener('click', () => {
    const target = document.querySelector(btn.getAttribute('data-target'));
    if (!target) return;

    // Adjust this offset as you like (header height + 100px buffer)
    const headerOffset = 100;

    const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });
  });
});



// document.querySelectorAll('.btn_cstm').forEach(button => {
//   button.addEventListener('click', function() {
//     const target = document.querySelector(this.getAttribute('data-target'));
//     if (target) {
//       target.scrollIntoView({ behavior: 'smooth' });
//     }
//   });
// });